import { render, staticRenderFns } from "./witnesses.vue?vue&type=template&id=530133df&scoped=true"
import script from "./witnesses.vue?vue&type=script&lang=js"
export * from "./witnesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530133df",
  null
  
)

export default component.exports